module.exports = __webpack_public_path__ + "img/closedloopLogo.6dcd592c.png";